// Série diária do drill-down de KPI (KpiDrawer), derivada da série real do
// dashboard (/api/dashboard: investment, impressions, clicks, leads por dia).

const ratio = (num, den, factor = 1) => (den > 0 ? (num / den) * factor : null)

// Cada KPI do drill-down é derivado dos campos diários da série
// (investment, impressions, clicks, leads).
export const KPI_META = {
  cpm: {
    icon: 'eye', linkTo: '/google-ads/campanhas', linkLabel: 'Ver Google Ads', format: 'currency',
    daily: (d) => ratio(d.investment, d.impressions, 1000),
  },
  cpc: {
    icon: 'link', linkTo: '/google-ads/campanhas', linkLabel: 'Ver Google Ads', format: 'currency',
    daily: (d) => ratio(d.investment, d.clicks),
  },
  ctr: {
    icon: 'trend_up', linkTo: '/google-ads/campanhas', linkLabel: 'Ver Google Ads', format: 'percent',
    daily: (d) => ratio(d.clicks, d.impressions, 100),
  },
  cpl: {
    icon: 'leads', linkTo: '/google-ads/leads', linkLabel: 'Ver leads', format: 'currency',
    daily: (d) => ratio(d.investment, d.leads),
  },
}

export const FALLBACK_META = { icon: 'chart', linkTo: '/google-ads', linkLabel: 'Ver Google Ads', format: 'number', daily: null }

const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

export function dayLabel(isoDate) {
  const [y, m, d] = (isoDate || '').split('-').map(Number)
  if (!y || !m || !d) return isoDate || ''
  return WEEKDAYS[new Date(y, m - 1, d).getDay()]
}

export function fmtValue(value, format) {
  if (value == null) return 'sem dados'
  if (format === 'percent') return `${value.toFixed(2).replace('.', ',')}%`
  const text = value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  return format === 'currency' ? `R$ ${text}` : text
}

export function buildDailySeries(meta, series) {
  if (!meta.daily || !Array.isArray(series)) return []
  return series.slice(-7).map((d) => ({ date: d.date, day: dayLabel(d.date), value: meta.daily(d) }))
}
